module.exports = __webpack_public_path__ + "static/media/couverture.8c7ae495.png";